var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentDonors(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "charity (5) 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z",
    fill: "#808000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4775 5C18.7095 5 18.0314 5.29711 17.5 5.86284C16.9685 5.29711 16.2905 5 15.5225 5C13.97 5 12.7539 6.21785 12.7539 7.77256C12.7539 9.41666 14.1103 10.4734 15.9875 11.936C16.3128 12.1895 16.6492 12.4516 17.0059 12.7369C17.1503 12.8524 17.3252 12.9102 17.5 12.9102C17.6748 12.9102 17.8497 12.8524 17.9941 12.7369C18.3508 12.4516 18.6871 12.1895 19.0125 11.936C20.8898 10.4734 22.2461 9.41666 22.2461 7.77256C22.2461 6.21785 21.03 5 19.4775 5Z",
    fill: "#AD3501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.04252 19.6447C4.12283 19.878 4.30672 20.0611 4.54075 20.1383L13.3209 22.7832C13.6565 22.8962 14.0303 22.7704 14.2294 22.4719L16.4834 19.09C16.6202 18.8846 16.6534 18.6273 16.5738 18.3948C16.4935 18.1615 16.3096 17.9784 16.0756 17.9012L7.29543 15.2562C6.9563 15.1411 6.58553 15.2694 6.38698 15.5675L4.13291 18.9494C3.99617 19.1549 3.96294 19.4122 4.04252 19.6447Z",
    fill: "#808000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.9576 19.6447C31.0372 19.4122 31.004 19.1549 30.8672 18.9494L28.6131 15.5675C28.4146 15.2694 28.0438 15.1411 27.7047 15.2562L18.9245 17.9012C18.6905 17.9784 18.5066 18.1615 18.4263 18.3948C18.3467 18.6273 18.38 18.8845 18.5167 19.09L20.7708 22.4719C20.9698 22.7705 21.3437 22.8962 21.6792 22.7832L30.4594 20.1383C30.6934 20.061 30.8772 19.878 30.9576 19.6447Z",
    fill: "#808000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.709 21.6044L15.5457 23.3496C14.9447 24.2483 13.8255 24.6222 12.8165 24.2827L7.16406 22.5862V27.8443C7.16406 28.1849 7.38191 28.487 7.7048 28.5944L16.709 31.5781V21.6044H16.709Z",
    fill: "#808000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.8359 27.8443V22.5863L22.1379 24.2974C21.2362 24.6039 20.0801 24.2852 19.4551 23.3511L18.291 21.6044V31.5782L27.2952 28.5945C27.6181 28.487 27.8359 28.185 27.8359 27.8443Z",
    fill: "#808000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.2601 12.1678C20.8668 12.497 20.4404 12.8294 19.9854 13.1839C19.6647 13.4337 19.3332 13.6919 18.9828 13.9723C18.5636 14.3076 18.0371 14.4923 17.5004 14.4923C16.9636 14.4923 16.4372 14.3076 16.018 13.9723C15.6676 13.692 14.1341 12.497 13.7408 12.1678L8.38965 13.9359L16.5348 16.3873C16.9081 16.51 17.2348 16.7143 17.4988 16.9758C17.7581 16.7161 18.0751 16.5155 18.4289 16.3989L26.6093 13.9353L21.2601 12.1678Z",
    fill: "#808000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentDonors);
export default __webpack_public_path__ + "static/media/recentDonors.8eb16aec742fb59d452090d7951d728d.svg";
export { ForwardRef as ReactComponent };